import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

const getShouldShowModularOnboarding = () => {
  return GrowthAcquisitionExperiments.preview('showModularOnboarding');
};

export { getShouldShowModularOnboarding };
